import aceConfig from 'ace/config';

export default {
  name: 'ace',

  initialize() {
    // Setting worker URLs explicitly allows Ember to replace them
    // with fingerprinted ones on build.
    aceConfig.setModuleUrl(
      'ace/mode/json_worker',
      new URL('cio/assets/ace/workers/worker-json.js', import.meta.url).toString(),
    );
    aceConfig.setModuleUrl(
      'ace/mode/javascript_worker',
      new URL('cio/assets/ace/workers/worker-javascript.js', import.meta.url).toString(),
    );
    aceConfig.setModuleUrl(
      'ace/mode/html_worker',
      new URL('cio/assets/ace/workers/worker-html.js', import.meta.url).toString(),
    );
  },
};
